import {Injectable} from '@angular/core';
import {Submission} from '@paperlessio/sdk/api/models';
import {SubmissionService} from '@paperlessio/sdk/api/services';
import {ToastService} from '@paperlessio/sdk/api/util';
import {Observable, of} from 'rxjs';
import {BaseStore} from './base.store';

@Injectable({providedIn: 'root'})
export class SubmissionStore extends BaseStore<Submission, SubmissionService> {
  constructor(service: SubmissionService, toast: ToastService) {
    super(service, toast);
  }

  /**
   * In contrast to BaseStore#init, this method will not return from this.all!
   */
  init(id: number, returnExisting = false, params = {}): Observable<Submission> {
    params['expand[]'] = params['expand[]'] || [];
    params['expand[]'].push(...Submission.expandable.getExpandableAttributes(
      'aggregated_submit_event_values',
      'aggregated_calculated_token_values',
      'aggregated_calculated_block_attributes'
    ));

    if (returnExisting && id === this.current?.value?.id && this.sameExpandParams(params)) {
      this._init(id, params).subscribe();
      return of(this.current.value);
    }

    if (returnExisting && !!this.all.value) {
      const found = this.all.value.data.find(x => x.id === id);
      if (!!found) {
        this.current.next(found);
      }
    }
    return this._init(id, params);
  }

  cancelFormSubmission(submission_id: number) {
    return this.service.cancelFormSubmission(submission_id);
  }

  // Like Block#block_owner_participant_ids but scoped to the current submission
  blockOwnerParticipantIdsForBlock(block_id: number): number[] {
    return this.current.value?.block_owner_mapping?.[block_id] ?? [];
  }
}
